export const POPULAR_THEMES = [
  {id: "cai", filterName: "cai", label: "Cai Shen"},
  {id: "zeus", filterName: "zeus", label: "Zeus"},
  {id: "plinko", filterClass: "plinko", label: "Plinkos"},
  {id: "tiger", filterName: "tiger", label: "Tigres"},
  {id: "crash", filterClass: "crash", label: "Crashes"},
  {id: "mines", filterClass: "mines", label: "Minas"},
  {id: "dragon", filterName: "dragon", label: "Dragones"},
  {id: "book", filterName: "book", label: "Libros"},
  {id: "sweet", filterName: "sweet", label: "Dulces"},
  {id: "fruit", filterName: "fruit", label: "Frutas"},
  {id: "wolf", filterName: "wolf", label: "Lobos"},
  {id: "chicken", filterName: "chicken", label: "Pollos"},
  {id: "joker", filterName: "joker", label: "Jokers"},
  {id: "sun", filterName: "sun", label: "Soles"},
  {id: "hot", filterName: "hot", label: "Hot"},
];
